import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { BlotterDefinitionImpl } from "../model/impl/BlotterDefinitionImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class BlotterDefinitionImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: BlotterDefinitionImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.blotterId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(1),
        false,
        encodable.blotterId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.blotterName != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(2),
        false,
        encodable.blotterName,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.entryUserId != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(3),
        false,
        encodable.entryUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.creationDts != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(4),
        false,
        encodable.creationDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.blotterType != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(5),
        false,
        encodable.blotterType,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.queryGroup != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(6),
        true,
        encodable.queryGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.isSystemBlotter != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(7),
        false,
        encodable.isSystemBlotter,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.assetClass != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(8),
        false,
        encodable.assetClass,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.lastUpdateDts != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(9),
        false,
        encodable.lastUpdateDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        BlotterDefinitionImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,BlotterDefinitionImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.String"],
    [3, "java.lang.Long"],
    [4, "java.util.Date"],
    [5, "com.bcdfx.model.BlotterType"],
    [6, "com.bcdfx.model.query.QueryGroup"],
    [7, "java.lang.Boolean"],
    [8, "com.bcdfx.model.AssetClass"],
    [9, "java.util.Date"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: BlotterDefinitionImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.blotterId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.blotterName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.entryUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.creationDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.BlotterType = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.blotterType = <CubiqTS.BlotterType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.QueryGroup = this.baseEncoder.readObject(
            true,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.queryGroup = <CubiqTS.QueryGroup>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.isSystemBlotter = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.AssetClass = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.assetClass = <CubiqTS.AssetClass>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.lastUpdateDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BlotterDefinitionImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,BlotterDefinitionImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return BlotterDefinitionImplEncoder.fidTypeMap.has(fid);
  }
}
